import {
    IAccountStatistic,
} from 'entities/account-statistics/types/account-statistic';

import {
    PAYMENT_PAGE_TYPE,
} from 'entities/payment-methods/constants';
import {
    PAYMENT_STATUS,
} from 'entities/payments/constants';

export function isPendingUpiIntentQr(accountStatistic: IAccountStatistic, isPendingState: boolean): boolean {
    if (isPendingState) {
        return false;
    }
    if (accountStatistic.paymentMethod.paymentPageType !== PAYMENT_PAGE_TYPE.UPI_INTENT_QR) {
        return false;
    }
    if (!accountStatistic.payment) {
        return false;
    }

    return [
        PAYMENT_STATUS.PENDING,
        PAYMENT_STATUS.IN_PROGRESS,
        PAYMENT_STATUS.NEED_CHECK,
        PAYMENT_STATUS.EXPIRED,
    ].includes(accountStatistic.payment.status);
}
